export default {
    configuration: window.configuration,
};
